module.exports = __webpack_public_path__ + "static/header-bannerbg-main-min-228414e4be4f3262835f513ec9d5ece3.png";